import { createLogger } from '@metron/shared';

const logger = createLogger('ApiConfig');

// API configuration
const isDevelopment = import.meta.env.DEV;
const isProduction = import.meta.env.PROD;

// In development, default to the Vite proxy (/api routes), but allow VITE_API_URL
// to override — set it in .env.local to point the local frontend at a deployed
// (e.g. cloud dev) backend. In production, use VITE_API_URL with a fallback.
export const apiConfig = {
  baseUrl: isDevelopment
    ? (import.meta.env.VITE_API_URL || '/api')
    : (import.meta.env.VITE_API_URL ||
      'https://4bpesz0sz9.execute-api.us-west-2.amazonaws.com/dev'),
};

// Helper function to build API URLs
export function getApiUrl(path: string): string {
  // Remove leading slash if present
  const cleanPath = path.startsWith('/') ? path.slice(1) : path;
  // Ensure baseUrl doesn't end with slash
  const cleanBase = apiConfig.baseUrl.endsWith('/')
    ? apiConfig.baseUrl.slice(0, -1)
    : apiConfig.baseUrl;

  return `${cleanBase}/${cleanPath}`;
}

// Common API endpoints
export const apiEndpoints = {
  preferences: getApiUrl('preferences'),
  health: getApiUrl('health'),
  metrics: getApiUrl('metrics'),
  metricsPlausible: getApiUrl('metrics/plausible'),
  ingestStatistics: getApiUrl('ingest-statistics'),
} as const;

// Log the configuration for debugging
logger.info({
  isDevelopment,
  isProduction,
  baseUrl: apiConfig.baseUrl,
  preferencesEndpoint: apiEndpoints.preferences,
}, 'API Configuration');
